/**
 * Launch feature flags. Plain constants (no env, no DB) so they tree-shake and
 * are safe to import from client components.
 *
 * AI_ASSIST_ENABLED gates every "ask AI / natural-language" surface across the
 * whole app — both the functional in-app surfaces (the editor AI tab + its
 * create-flow prompt bar) AND the marketing/messaging that promotes them (the landing "Ask your
 * map" section, the footer "Ask your map" link, the About "Ask in plain
 * language" point, and the pricing page's natural-language feature copy +
 * testimonials). Hidden for launch (kept off consistently across the app);
 * flip to `true` to bring every AI surface — functional and promotional — back
 * everywhere at once.
 *
 * NOTE: the Help center's AI content (the "AI map building & questions" article
 * and AI mentions in other docs) is NOT gated here — it's generated from Linear
 * Living Docs (`content/help/*.md`, never hand-edited), so it's hidden at the
 * source in Linear + re-pull, tracked separately.
 */
export const AI_ASSIST_ENABLED = true;

/** Ask your map is included with Pro and Pro Plus. Free/Lite trials are a
 * separate future policy and must not be inferred from generic paid status. */
export function canUseAiAssist(tier: string): boolean {
  return tier === "pro" || tier === "pro_plus";
}
